exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2df0cd66] .ant-table-tbody>tr>td{padding:8px 16px}.deleted-date[data-v-2df0cd66]{text-decoration:line-through}[data-v-2df0cd66] svg{vertical-align:unset}[data-v-2df0cd66] .ant-table-placeholder{border-bottom:0}", ""]);

// exports
